import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de.json";

// German only. Every visible string lives in de.json; components use
// `useTranslation("translation", { keyPrefix: "<area>" })` and `t("key")`.
i18n.use(initReactI18next).init({
  resources: { de: { translation: de } },
  lng: "de",
  fallbackLng: "de",
  interpolation: { escapeValue: false },
  returnNull: false,
});
